import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { LoadingScreen } from '@/components/ui/LoadingScreen'
import { ProtectedRoute } from '@/router/ProtectedRoute'

// Auth pages
import Login          from '@/pages/auth/Login'
import Register       from '@/pages/auth/Register'
import ForgotPassword from '@/pages/auth/ForgotPassword'
import ResetPassword  from '@/pages/auth/ResetPassword'
import SelectRole     from '@/pages/auth/SelectRole'
import AuthCallback   from '@/pages/auth/AuthCallback'

// App shell + portals
import AppShell              from '@/pages/app/AppShell'
import SchoolOverview        from '@/pages/app/school/SchoolOverview'
import InstructorDashboard   from '@/pages/app/instructor/InstructorDashboard'
import Enroll               from '@/pages/app/instructor/Enroll'
import StudentHome           from '@/pages/app/student/StudentHome'
import Settings              from '@/pages/app/shared/Settings'

export default function App() {
  const { loading } = useAuth()

  if (loading) return <LoadingScreen />

  return (
    <Routes>
      {/* Public auth routes */}
      <Route path='/login'          element={<Login />} />
      <Route path='/register'       element={<Register />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/auth/reset-password' element={<ResetPassword />} />
      <Route path='/auth/select-role'    element={<SelectRole />} />
      <Route path='/auth/callback'       element={<AuthCallback />} />

      {/* School admin portal */}
      <Route path='/app/school' element={
        <ProtectedRoute requiredRole='school_admin'>
          <AppShell role='school_admin' />
        </ProtectedRoute>
      }>
        <Route index element={<SchoolOverview />} />
        <Route path='settings' element={<Settings />} />
      </Route>

      {/* Instructor portal */}
      <Route path='/app/instructor' element={
        <ProtectedRoute requiredRole='instructor'>
          <AppShell role='instructor' />
        </ProtectedRoute>
      }>
        <Route index element={<InstructorDashboard />} />
        <Route path='enroll'   element={<Enroll />} />
        <Route path='settings' element={<Settings />} />
      </Route>

      {/* Student portal */}
      <Route path='/app/student' element={
        <ProtectedRoute requiredRole='student'>
          <AppShell role='student' />
        </ProtectedRoute>
      }>
        <Route index element={<StudentHome />} />
        <Route path='settings' element={<Settings />} />
      </Route>

      {/* Root redirect */}
      <Route path='/' element={<Navigate to='/login' replace />} />
      <Route path='*' element={<Navigate to='/login' replace />} />
    </Routes>
  )
}
